import { render, staticRenderFns } from "./userorder.vue?vue&type=template&id=0a0de8ef&scoped=true"
import script from "./userorder.vue?vue&type=script&lang=js"
export * from "./userorder.vue?vue&type=script&lang=js"
import style0 from "./userorder.vue?vue&type=style&index=0&id=0a0de8ef&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a0de8ef",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VCard,VCol,VDivider,VRow,VSelect})
